module.exports = __webpack_public_path__ + "img/logo-tbc-solutions.4f302e54.png";